import {ChangeDetectionStrategy, Component, Inject, Input, OnInit} from "@angular/core";
import {PackageSpotsPipe} from "../../../../commons/angular/pipes/package-spots.pipe";

require('./service-spots-indication.scss');
@Component({
  standalone: false,
  selector: 'app-service-spots-indication',
  templateUrl: './service-spots-indication.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServiceSpotsIndicationComponent implements OnInit {

  @Input() packageList: any[];
  @Input() serviceType: string;

  public spotsSum: number;

  constructor(@Inject(PackageSpotsPipe) private packageSpotsPipe: PackageSpotsPipe) {
  }

  ngOnInit() {
    if (this.packageList) {
      this.spotsSum = this.packageSpotsPipe.transform(this.packageList[0]);
    }
  }

}
